module.exports = __webpack_public_path__ + "img/especialista1.4f605836.png";